import { render, staticRenderFns } from "./imageCarousel.vue?vue&type=template&id=07cd5352&"
import script from "./imageCarousel.vue?vue&type=script&lang=js&"
export * from "./imageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07cd5352')) {
      api.createRecord('07cd5352', component.options)
    } else {
      api.reload('07cd5352', component.options)
    }
    module.hot.accept("./imageCarousel.vue?vue&type=template&id=07cd5352&", function () {
      api.rerender('07cd5352', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2n1n1Tw2dFAm3/JS/imageCarousel.vue"
export default component.exports